import React, { useEffect, useState, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Button } from 'react-bootstrap';

const headers = [
  'Site No',
  'Site Type',
  'Client Name',
  'City',
  'Area/Sector',
  'Zone',
  'Lead Owner',
  'Assignee Name',
  'Created On',
  'Status',
];

const SiteEngineerDetails = ({
  match,
  getSiteEngineerDetails,
  siteEngineerDetails,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const headerBtns = () => {
    return (
      <Button href="" className="filter-hamburger btn btn-transparent">
        <img src={Images?.Filter} alt="" />
        {localization.showFilters}
      </Button>
    );
  };

  useEffect(() => {
    if (getSiteEngineerDetails !== null)
      (async () => {
        setIsLoading(true);
        await getSiteEngineerDetails(match.params.id);
        setIsLoading(false);
      })();
  }, [getSiteEngineerDetails, match.params.id]);

  useEffect(() => {
    const tableData = [
      'site_no',
      'site_type',
      'client_name',
      'city',
      'area_sector',
      'zone',
      'lead_owner',
      'assignee_name',
      'created_at',
      'status',
    ];

    if (siteEngineerDetails && siteEngineerDetails.site_list) {
      const data = siteEngineerDetails.site_list.map((element) =>
        Object.assign({}, ...tableData.map((key) => ({ [key]: element[key] })))
      );
      data && setListData(data);
    }
  }, [siteEngineerDetails]);

  return (
    <Layout
      title={localization.allocatedSiteList}
      Buttons={headerBtns}
      isLoading={isLoading}
      isGoback
      linkUrl={`${baseUrl}/site-engineer-list`}
    >
      <TableSection
        data={listData}
        headers={headers}
        detailList={siteEngineerDetails && siteEngineerDetails.site_list}
      />
    </Layout>
  );
};

export default SiteEngineerDetails;
